export const STATES = {
    IN_USE: 1,
    ON_STOCK: 2,
    UNDER_REPAIR: 3,
    ORDERED: 4,
    WRITE_OFF: 5,
    IN_TRANSIT_TO_USER: 7,
    IN_TRANSIT_TO_STOCK: 8,
    IN_OFFICE: 9,
};

export const STATES_WITHOUT_ORDERED = {
    IN_USE: 1,
    ON_STOCK: 2,
    UNDER_REPAIR: 3,
    WRITE_OFF: 5
};

export const STATES_BULK_EDIT = {
    UNDER_REPAIR: 3,
    IN_OFFICE: 9,
    WRITE_OFF: 5
};
export const TEMPORARY_STATES_BULK_EDIT = {
    UNDER_REPAIR: 3,
    WRITE_OFF: 5
};

export const STATES_FOR_EDIT_ASSIGNED = {
    IN_USE: 1,
    IN_TRANSIT_TO_STOCK: 8,
};

export const STATES_WITHOUT_IN_USE_AND_ORDERED = {
    ON_STOCK: 2,
    UNDER_REPAIR: 3,
    WRITE_OFF: 5
};

export const STATES_WITH_IN_OFFICE = {
    IN_OFFICE: 9,
    ON_STOCK: 2,
    UNDER_REPAIR: 3,
    WRITE_OFF: 5,
};

export const STATES_EDIT_IN_OFFICE = {
    IN_OFFICE: 9,
    ON_STOCK: 2,
};

export const STATES_FOR_CREATE = {
    ON_STOCK: 2,
    ORDERED: 4,
};

export const STATES_FOR_ASSIGN_DEVICE = {
    IN_USE: 1,
    IN_TRANSIT_TO_USER: 7,
};

export const MOBILE_DEVICE_STATES = {
    IN_USE: 1,
    ON_STOCK: 2,
    UNDER_REPAIR: 3,
};

export const MOBILE_DEVICE_STATES_WITHOUT_IN_USE = {
    ON_STOCK: 2,
    UNDER_REPAIR: 3,
};

export const MOBILE_DEVICE_STATE_ON_STOCK = {
    ON_STOCK: 2,
};

export const WORKING_STATES = {
    WORKING: { value: 1, translateKey: 'working' },
    NON_WORKING: { value: 2, translateKey: 'nonWorking' },
    WORKING_CONDITIONALLY: { value: 3, translateKey: 'workingConditionally' }
};

export const STATES_KEY = {
    IN_USE: { value: 1, translateKey: 'inUse' },
    ON_STOCK: { value: 2, translateKey: 'onStock' },
    UNDER_REPAIR: { value: 3, translateKey: 'underRepair' },
    ORDERED: { value: 4, translateKey: 'ordered' },
    WRITE_OFF: { value: 5, translateKey: 'writeOff' },
    IN_TRANSIT_TO_USER: { value: 7, translateKey: 'inTransitToUser' },
    IN_TRANSIT_TO_STOCK: { value: 8, translateKey: 'inTransitToStock' },
    IN_OFFICE: { value: 9, translateKey: 'inOffice' },
};

export const PRIMARY_STATES = {
    YES: true,
    NO: false
};

export const INFRASTRUCTURE_UNIT = {
    YES: true,
    NO: false
};

export const LEASING_CONTRACT = {
    YES: true,
    NO: false
};

export const FREE_LICENSE_STATES = {
    YES: true,
    NO: false
};

export const DOWNLOAD_ACT_TYPES = {
    RECEPTION: 'reception',
    RETURN: 'return'
};

export const DA_LINK_PROPERTIES = {
    DEVICE: {
        RECEPTION: 'devicePdfReport',
        RETURN: 'deviceReturnPdfReport'
    },
    MOB_DEVICE: {
        RECEPTION: 'PdfReport',
        RETURN: 'returnPdfReport'
    }
};

export const ENTITY = {
    DEVICE: 'devices',
    MOB_DEVICE: 'mobileDevices'
};

export const EXPANDER_CONTENT_TYPES = {
    assignCountProfile: 'assignCountProfile',
    deviceProfile: 'deviceProfile',
    userProfile: 'userProfile'
};

export const TICKET_LINK = {
    prefixId: 2,
    label: 'LE',
    name: 'https://exadel.atlassian.net/browse/LE-'
};

export const JIRA_TICKET_NUMBER_CHARACTER = {
    min: 1,
    max: 5
};
